import React from "react";
import UserList from "./UserList";
import { RemovableUser } from "components/Removables/RemovableUser";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { ModalPickerProps } from "../props";

interface Props extends ModalPickerProps<server.dto.UserSmall> {
  onUserChange?: (newValue: server.dto.UserSmall, environment: server.dto.Environments) => void

  canChooseDeactivated?: boolean
  canChooseExternal?: boolean

  customLabel?: string
  excludeUsers?: number[]
}

const UserModalPicker = (props: Props) => {
  const { onUserChange, canChooseDeactivated, canChooseExternal, customLabel, excludeUsers, ...rest } = props;
  const onChange = (value: server.dto.UserSmall) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };
  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={customLabel ?? RESX.SoUser.Users}
    modalSize="tiny"


    renderModalContent={(closeModal) => <UserList
      excludedUsers={excludeUsers}
      onUserSelected={(user, environment) => {
        closeModal();
        onChange(user);
        onUserChange?.(user, environment);
      }}
      canChooseDeactivated={canChooseDeactivated}
      canChooseExternal={canChooseExternal}
    />}
    renderRemovable={(props) => <RemovableUser {...props} />}
    {...rest}
  />;
};

export default UserModalPicker;